import type { AccountSummary } from '@fruitful/types';

import { requestBuilder } from '../../../../http/RequestBuilder';
import { useRefetchHolisticSummaryMutationOptions } from '../useRefetchHolisticSummaryMutationOptions';

interface UpsertOrionAccountBody {
    id: string; // For Grove, we only allow updating existing addresses for now.
    userId: string;
    name?: string;
    holisticCategory?: string;
    isHidden?: boolean;
}

const useUpsertOrionAccount = requestBuilder.mutation<
    AccountSummary,
    UpsertOrionAccountBody
>({
    endpoint: '/api/admin/holistic/accounts/orion',
    method: 'POST',
});

export const useUpsertOrionAccountAndRefetch = (
    membershipId: string | null,
) => {
    const refetchHolisticSummaryMutationOptions =
        useRefetchHolisticSummaryMutationOptions(membershipId);

    const { mutateAsync } = useUpsertOrionAccount(
        refetchHolisticSummaryMutationOptions,
    );

    const upsertOrionAccountAsync = async (body: UpsertOrionAccountBody) => {
        return await mutateAsync({
            body,
        });
    };

    return {
        upsertOrionAccountAsync,
    };
};
